// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message__desc[data-v-a999a91e]{white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
